module.exports = __webpack_public_path__ + "img/1F6BE.aee21f6a.svg";